import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import "../css/otp.css";
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { useState } from 'react';
import axios from "axios";
import { CircularProgress } from '@mui/material';
import {useNavigate} from "react-router-dom";
import Alert from '@mui/material/Alert';
export default function Otpvalidation({name,email,mobile,about}){
  const [loading,setloading]=useState(false);
  const [otp,setotp]=useState();
  const [error,seterror]=useState(false);
  const [success,setsuccess]=useState(false);
  const [sent,setsent]=useState(false);
  const [errortext,seterrortext]=useState("");
  const [reserror,setreserror]=useState(false);
  const Navigate=useNavigate();
  async function verifyhandler(){
    setsuccess(false);
setloading(true);
setreserror(false);
setsent(false);
if(!otp){
seterror(true);
setloading(false);
return;
}
try {
    const res=await axios.post(`${process.env.REACT_APP_NODEJS}/verify`,{
        name,
        email,
        otp,
        mobile,about
    });
    if(res.data.error){
        seterror(true);
        seterrortext(res.data.error);
    }
    else{
   setsent(true);
   setTimeout(() => {
    Navigate("/");
   }, 3000);
        
    }
  
} catch (error) {
    console.log(error);
    setreserror(true);
}
setloading(false);
  }
  async function resendOTPHandler(){
    setsuccess(false);
   setreserror(false);
setloading(true);
try {
   const res=await axios.post(`${process.env.REACT_APP_NODEJS}/otp`,{email }) ;
   if(res.data.error)
    seterror(true);
   else{
  setsuccess(true);
setTimeout(() => {
    setsuccess(false);
}, 3000);
   }

} catch (error) {
    console.log(error);
    setreserror(true);
}
setloading(false);
  }
  
 
    return(
    <div id='otp-form'>
        {success  &&
         <Alert severity="success" >OTP has been sent</Alert>
         }
        {sent &&
         <Paper elevation={3}>
         <Alert severity="success">Thank you! I will contact you soon</Alert> 
         <CircularProgress /> <Typography  variant="body2" color="text.secondary">Redirecting you</Typography>
         </Paper>
         }
         {
          error && 
          <Alert severity="error">{errortext||"Something went wrong"}</Alert>
         }
         {
          reserror  &&
          <Alert severity="error">Something went wrong,Try again</Alert>
         }
       { !sent &&  <Paper elevation={3}>
           
             <Typography variant="body2" >
          Enter otp sent to 
          <Typography  variant="body2" color="text.secondary">
          {email}
          </Typography>
        </Typography>
        <Typography  variant="body2" color="text.secondary">
           Valid for 5 min
          </Typography>
          <br />

          <TextField  focused  inputProps={{ inputMode: 'numeric', pattern: '[0-9]{6}' }} onChange={(e)=>{setotp(e.target.value)}} error={error}/>

          <Button variant="text" onClick={resendOTPHandler}  disabled={loading}>
         Resend OTP
          </Button>
          <Button variant="contained" onClick={verifyhandler} disabled={loading}>Verify
          </Button>
            </Paper> }
       </div>
    );
}